import React from 'react';
import { FiSun } from 'react-icons/fi';
import './SpinningSun.css';

/**
 * Standardized loading component with rotating sun
 * This is the ONLY loading component that should be used throughout the app
 * 
 * @param {string} size - Size preset: 'small', 'medium', 'large', 'extra-large', 'massive'
 * @param {string} message - Optional loading message to display
 * @param {boolean} fullscreen - Whether to center on full screen
 * @param {string} className - Additional CSS classes
 */
const SpinningSun = ({ 
  size = 'large', 
  message = '', 
  fullscreen = false, 
  className = '' 
}) => {
  if (fullscreen) {
    return (
      <div className={`spinning-sun-fullscreen ${className}`}>
        <div className="spinning-sun-content">
          <FiSun className={`spinning-sun ${size}`} />
          {message && <div className="spinning-sun-message">{message}</div>}
        </div>
      </div>
    );
  }

  return (
    <div className={`spinning-sun-container ${className}`}>
      <FiSun className={`spinning-sun ${size}`} />
      {message && <div className="spinning-sun-message">{message}</div>}
    </div>
  );
};

export default SpinningSun;